import React from 'react';
import Modal from 'components/modal';
import Button from 'components/button';
import closeIcon from 'assets/icons/closeIcon.svg';

/**
 * Lightweight ChatGPT/Claude-style "Delete chat?" confirmation modal.
 * Unlike DeleteDocumentPopup, this does NOT require typing a keyword —
 * just Cancel / Delete buttons, matching the chat sidebar UX patterns.
 */
const DeleteChatPopup = ({
  isOpen,
  chatTitle,
  onCancel,
  onConfirm,
  isDeleting = false,
}) => {
  const safeTitle = chatTitle && chatTitle.trim().length > 0 ? chatTitle : 'this chat';

  return (
    <Modal show={isOpen} onClose={isDeleting ? undefined : onCancel} width="max-w-[392px]">
      <div className="p-5">
        <div className="flex justify-between items-start">
          <div className="p-sm-bold mb-4 w-[15rem]">Delete chat?</div>
          <img
            src={closeIcon}
            alt="Close"
            className="cursor-pointer h-3"
            onClick={() => {
              if (!isDeleting) onCancel();
            }}
          />
        </div>
        <p className="p-xs-regular mb-6">
          This will permanently delete{' '}
          <span className="p-xs-bold">&ldquo;{safeTitle}&rdquo;</span> and all of its
          messages. You can&apos;t undo this.
        </p>
        <div className="flex justify-end gap-2">
          <Button
            variant="tertiary"
            onClick={onCancel}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting…' : 'Delete'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteChatPopup;
